// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import { RouteComponentProps } from "react-router"
import { useTitle } from "react-use"
import { RouteDefinition } from "app/routing"

type OwnProps = {
  route: RouteDefinition,
} & RouteComponentProps

export type Props = OwnProps

const RouteWrapper = ({
  route: {
    main: Main,
    sidebar: Sidebar,
    title,
  },
  ...routeProps
}: Props): React.ReactElement<Props> | null => {
  // eslint-disable-next-line lingui/no-unlocalized-strings
  useTitle(`${title} | WiseTime Console`)
  return (
    <React.Fragment>
      {Sidebar && <Sidebar />}
      {Main && <Main {...routeProps} />}
    </React.Fragment>
  )
}

export default RouteWrapper

